import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountInfoPresentationComponent } from './components/account-info-presentation/account-info-presentation.component';
import { SharedModule } from '@mpt-fo/common/shared/shared.module';
import { GenericFilterModalComponent } from './components/generic-filter-modal/generic-filter-modal.component';
import { PaymentsFilterModalComponent } from './components/payments-filter-modal/payments-filter-modal.component';
import { ExportPageComponent } from './components/export-page/export-page.component';
import { CustomerDetailsPresentationComponent } from './components/customer-details-presentation/customer-details-presentation.component';
import { MoniepointAccountInfoPresentationComponent } from './components/moniepoint-account-info-presentation/moniepoint-account-info-presentation.component';
import { UtilitiesModule } from '@mpt-fo/common/utilities/utilities.module';
import { NetworkProviderFilterModalComponent } from './components/network-provider-filter-modal/network-provider-filter-modal.component';
import { AirtimeDataResultComponent } from './modals/airtime-data-result/airtime-data-result.component';
import { PaymentSummaryComponent } from './components/payment-summary/payment-summary.component';
import { OverdraftLimitDisplayComponent } from './components/overdraft-limit-display/overdraft-limit-display.component';
import { TransactionDownloadComponent } from './modals/transaction-download/transaction-download.component';
import { MFAAlertModalComponent } from './components/mfa-alert-modal/mfa-alert-modal.component';
import { MFASetupAlertModalComponent } from '@mpt-fo/common/shared/components/mfa-setup-alert-modal/mfa-setup-alert-modal.component';
import { KamonaModule } from '@mpt-fo/common/kamona/kamona.module';

@NgModule({
    declarations: [
        AccountInfoPresentationComponent,
        GenericFilterModalComponent,
        PaymentsFilterModalComponent,
        ExportPageComponent,
        CustomerDetailsPresentationComponent,
        MoniepointAccountInfoPresentationComponent,
        NetworkProviderFilterModalComponent,
        AirtimeDataResultComponent,
        PaymentSummaryComponent,
        OverdraftLimitDisplayComponent,
        TransactionDownloadComponent,
        MFASetupAlertModalComponent,
        MFAAlertModalComponent,
    ],
    imports: [CommonModule, SharedModule, UtilitiesModule, KamonaModule],
    exports: [
        AccountInfoPresentationComponent,
        GenericFilterModalComponent,
        ExportPageComponent,
        CustomerDetailsPresentationComponent,
        MoniepointAccountInfoPresentationComponent,
        PaymentSummaryComponent,
        OverdraftLimitDisplayComponent,
        TransactionDownloadComponent,
        MFAAlertModalComponent,
    ],
})
export class PaymentsSharedModule {}
